    angular.module('document', ['core'])
        .factory('Document', function ($resource) {
            return $resource('/crm/api/document', {}, {
                table: {method: 'GET', isArray: false, url: '/crm/api/document/table'},
                objectTypes: {method: 'GET', isArray: true, url: '/crm/api/document/object-types'},
                lastComments: {method: 'GET', isArray: false, url: '/crm/api/document/comments'},
                comments: {method: 'GET', isArray: true, url: '/crm/api/:type/:id/comments'},
                postComment: {method: 'POST', url: '/crm/api/:type/:id/comments'}
            });
        })
        .service('DocumentFilterService', function ($cookies) {
            let defaultFilters = {
                forMe: true,
                managedByMe: false,
                subscribed: false,
                status: ['SCHEDULED'],
                type: [],
                showInCalendar: true
            };

            let service = () => {

            };
            service.filters = $cookies.getObject("dashboard-document-filters") || defaultFilters;
            service.toggle = name => service.filters[name] = !service.filters[name];
            service.save = () => {
                const merged = Object.assign({}, defaultFilters, service.filters);
                $cookies.putObject("dashboard-document-filters", merged);
            };
            service.clear = () => {
                service.filters = {};
                $cookies.putObject("dashboard-document-filters", service.filters);
            };
            service.get = () => $cookies.getObject("dashboard-document-filters") || defaultFilters;
            return service;
        });
